import Vue from 'vue'
import Router from 'vue-router'
// import home from '@/pages/home'
// import cmappax from '@/pages/cmappax'
// import consult from '@/pages/consult'
//import onemap from '@/pages/onemap'
//import ids from '@/pages/ids'
//import sds from '@/pages/sds'
//import mids from '@/pages/mids'
//import csps from '@/pages/csps'
//import indoor from '@/pages/indoor'
//import ar from '@/pages/ar'
//import easylease from '@/pages/easylease'
//import easytowalk from '@/pages/easytowalk'
//import shopping from '@/pages/shopping'
//import hospital from '@/pages/hospital'
//import building from '@/pages/building'
//import traffic from '@/pages/traffic'
//import edu from '@/pages/edu'
//import about from '@/pages/about'
//import test from '@/pages/test'
//import messageBoard from '@/pages/messageboard'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/pages/home'], resolve),
      meta: {
        title: '创互 | CHAUNVE | 官方网站'
      }
    }, {
      path: '/m1',
      name: 'm1',
      component: resolve => require(['@/pages/m1'], resolve),
      meta: {
        title: '运维监护仪 | 创互 | CHAUNVE'
      }
    }, {
      path: '/c1',
      name: 'c1',
      component: resolve => require(['@/pages/c1'], resolve),
      meta: {
        title: '自助机 CKIOSK  C1 | 创互 | CHAUNVE'
      }
    }, {
      path: '/c2',
      name: 'c2',
      component: resolve => require(['@/pages/c2'], resolve),
      meta: {
        title: '自助机 CKIOSK  C2 | 创互 | CHAUNVE'
      }
    }, {
      path: '/d1',
      name: 'd1',
      component: resolve => require(['@/pages/d1'], resolve),
      meta: {
        title: '自助机 CKIOSK  d1 | 创互 | CHAUNVE'
      }
    }, {
      path: '/cmappax',
      name: 'cmappax',
      component: resolve => require(['@/pages/cmappax'], resolve),
      meta: {
        title: 'cmappax | 可在线绘制不同个性风格地图的工具 | 创互 | CHAUNVE'
      }
    }, {
      path: '/consult',
      name: 'consult',
      component: resolve => require(['@/pages/consult'], resolve),
      meta: {
        title: '咨询顾问 | 创互 | CHAUNVE'
      }
    }, {
      path: '/onemap',
      name: 'onemap',
      component: resolve => require(['@/pages/onemap'], resolve),
      meta: {
        title: 'one map | 创互 | CHAUNVE'
      }
    }, {
      path: '/ids',
      name: 'ids',
      component: resolve => require(['@/pages/ids'], resolve),
      meta: {
        title: '互动指南系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/sds',
      name: 'sds',
      component: resolve => require(['@/pages/sds'], resolve),
      meta: {
        title: '静态指南系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/mids',
      name: 'mids',
      component: resolve => require(['@/pages/mids'], resolve),
      meta: {
        title: '多媒体信息发布系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/csps',
      name: 'csps',
      component: resolve => require(['@/pages/csps'], resolve),
      meta: {
        title: '自助寻车缴费系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/indoor',
      name: 'indoor',
      component: resolve => require(['@/pages/indoor'], resolve),
      meta: {
        title: '室内导航系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/ar',
      name: 'ar',
      component: resolve => require(['@/pages/ar'], resolve),
      meta: {
        title: 'AR导航系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/bi',
      name: 'bi',
      component: resolve => require(['@/pages/bi'], resolve),
      meta: {
        title: '商业经营可视化 | 创互 | CHAUNVE'
      }
    }, {
      path: '/ads',
      name: 'ads',
      component: resolve => require(['@/pages/ads'], resolve),
      meta: {
        title: '广告预约系统 | 创互 | CHAUNVE'
      }
    }, {
      path: '/easylease',
      name: 'easylease',
      component: resolve => require(['@/pages/easylease'], resolve),
      meta: {
        title: '路易寻 | 创互 | CHAUNVE'
      }
    }, {
      path: '/easytowalk',
      name: 'easytowalk',
      component: resolve => require(['@/pages/easytowalk'], resolve),
      meta: {
        title: '云招商 | 创互 | CHAUNVE'
      }
    }, {
      path: '/shopping',
      name: 'shopping',
      component: resolve => require(['@/pages/shopping'], resolve),
      meta: {
        title: '购物中心行业解决方案 | 创互 | CHAUNVE'
      }
    }, {
      path: '/hospital',
      name: 'hospital',
      component: resolve => require(['@/pages/hospital'], resolve),
      meta: {
        title: '医院解决方案 | 创互 | CHAUNVE'
      }
    }, {
      path: '/building',
      name: 'building',
      component: resolve => require(['@/pages/building'], resolve),
      meta: {
        title: '写字楼解决方案 | 创互 | CHAUNVE'
      }
    }, {
      path: '/traffic',
      name: 'traffic',
      component: resolve => require(['@/pages/traffic'], resolve),
      meta: {
        title: '交通行业决方案 | 创互 | CHAUNVE'
      }
    }, {
      path: '/edu',
      name: 'edu',
      component: resolve => require(['@/pages/edu'], resolve),
      meta: {
        title: '教育行业决方案 | 创互 | CHAUNVE'
      }
    }, {
      path: '/about',
      name: 'about',
      component: resolve => require(['@/pages/about'], resolve),
      meta: {
        title: '关于我们 | 创互 | CHAUNVE'
      }
    }, {
      path: '/messageboard',
      name: 'messageboard',
      component: resolve => require(['@/pages/messageboard'], resolve),
      meta: {
        title: '留言板 | 创互 | CHAUNVE'
      }
    },

  ]
})
export default router
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next();
})


// WEBPACK FOOTER //
// ./src/plugs/router/index.js